import { z } from 'zod';
import { applySignatureRefinement, signatureDetailsSchema } from '../shared/signature';
export const hhccnValidationSchema = z.object({
    id: z.string(),
    data: z
        .object({
        language: z.enum(['en', 'es', 'zh', 'ko', 'vi']).default('en'),
        startingDate: z.string().min(10, 'Starting date is required'),
        changes: z
            .array(z.object({
            service: z.string(),
            reason: z.string(),
        }))
            .optional(),
        noticeReason: z.enum(['doctor-order', 'agency-decision']),
        optionalDetails: z.string().optional(),
        patientSigned: z.boolean().nullish(),
        signedDate: z.string().nullish(),
        signatureDetails: signatureDetailsSchema,
    })
        .superRefine((data, ctx) => {
        applySignatureRefinement(ctx, data, {
            signatureMessage: 'Patient or authorized representative signature is required',
            requireFullDate: true,
        });
    }),
});
